import React from 'react';

import LineIcon from '../components/LineIcon';
import { formatPlate } from '../garage/format';
import Stars from './Stars';
import { formatEvaluationDate } from './providerFormat';

// Uma linha por avaliacao: cliente, placa e data; a nota a direita.
// Etiqueta so quando pede atencao (cliente que nao indicaria).
export default function EvaluationRow({ evaluation, onOpen }) {
  const meta = [formatPlate(evaluation.plate), formatEvaluationDate(evaluation.date)].filter(Boolean).join(' · ');

  return (
    <li>
      <button type='button' className='pv-row' onClick={() => onOpen(evaluation)}>
        <span className='pv-row-text'>
          <strong>{evaluation.client}</strong>
          <span>{meta}</span>
          {evaluation.comment && <span className='pv-row-comment'>“{evaluation.comment}”</span>}
        </span>
        <span className='pv-row-side'>
          <Stars value={evaluation.average} />
          {!evaluation.indicate && <span className='gs-chip gs-chip-warn'>Não indicaria</span>}
        </span>
        <LineIcon name='chevronRight' size={18} className='pv-row-chevron' />
      </button>
    </li>
  );
}
